module.exports = __webpack_public_path__ + "img/gate_1_3.eef1dfcb.png";